import { SubscriptionPlan, SubscriptionPlans } from 'src/constants/SubscriptionPlan';

export function isFreeTrialSubscription(subscriptionPlan: SubscriptionPlan): boolean {
    return subscriptionPlan === SubscriptionPlans.FREE_TRIAL;
}
